// Configuração da automação de WhatsApp (Evolution API via n8n).
// Cada condomínio conecta o próprio número; o sistema envia as mensagens sozinho.
export const WHATSAPP_API = {
  baseUrl:
    import.meta.env.VITE_WHATSAPP_API_URL ||
    "https://n8n-n8n.uge2q4.easypanel.host/webhook",
  token: import.meta.env.VITE_WHATSAPP_API_TOKEN || "itacondo-wa-2026",
}

export type WhatsAppStatus = "desconectado" | "aguardando_leitura" | "conectado" | "connecting"

export interface WhatsAppConnection {
  ok: boolean
  instancia?: string
  conectado?: boolean
  estado?: WhatsAppStatus
  qrcode?: string | null
  pairingCode?: string | null
  ja_conectado?: boolean
  erro?: string
}

async function chamar<T>(rota: string, corpo: Record<string, unknown>): Promise<T> {
  const resposta = await fetch(`${WHATSAPP_API.baseUrl}/${rota}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token: WHATSAPP_API.token, ...corpo }),
  })

  if (!resposta.ok) {
    throw new Error(`Falha na automação de WhatsApp (${resposta.status})`)
  }
  return (await resposta.json()) as T
}

/** Cria/reconecta a instância do condomínio e devolve o QR Code para leitura. */
export function conectarWhatsApp(condominiumId: string, nome?: string) {
  return chamar<WhatsAppConnection>("condo-wa-connect", { condominium_id: condominiumId, nome })
}

/** Consulta se o número do condomínio está conectado. */
export function statusWhatsApp(condominiumId: string) {
  return chamar<WhatsAppConnection>("condo-wa-status", { condominium_id: condominiumId })
}

/** Desconecta o número do condomínio. */
export function desconectarWhatsApp(condominiumId: string) {
  return chamar<WhatsAppConnection>("condo-wa-disconnect", { condominium_id: condominiumId })
}

/** Envia mensagem para um ou vários números (com intervalo automático anti-bloqueio). */
export function enviarWhatsApp(params: {
  condominiumId: string
  numeros: string[]
  texto: string
}) {
  return chamar<{ ok: boolean; enviados: number; falhas: number; total: number; erro?: string }>(
    "condo-wa-send",
    { condominium_id: params.condominiumId, numeros: params.numeros, texto: params.texto },
  )
}
